import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[appI18nicDateTime]',
})
export class I18nicDateTimeDirective {
  constructor() {}

  /** Cambia valores del inglés al español en los componente de Ionic: ion-datetime */
  @HostBinding('attr.placeholder') placeholder = 'Seleccione';
  @HostBinding('attr.cancel-text') cancelText = 'Cancelar';
  @HostBinding('attr.done-text') doneText = 'Aceptar';
  @HostBinding('attr.day-names') dayNames: string[] = [
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
    'Domingo',
  ];
  @HostBinding('attr.day-short-names') dayShortNames: string[] = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];
  @HostBinding('attr.month-names') monthNames: string[] = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];
  @HostBinding('attr.month-short-names') monthShortNames: string[] = [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
  ];
}
